export default "__VITE_ASSET__iD6LsDnA__"